// extracted by css-extract-rspack-plugin
export default {"badge":"badge-X0ilqz text-interactive-label"};